const getActionByRoute = () => {
  const action = document.querySelector('meta[name="dispatcher"]');
  const routeRaw = action && action.getAttribute('content');
  const routeSplited = routeRaw.split('.');

  return {
    controller: routeSplited[0],
    action: routeSplited[1]
  };
};

export default getActionByRoute;



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/utils/getActionByRoute.js